import { render, staticRenderFns } from "./xiazai.vue?vue&type=template&id=366b857e"
import script from "./xiazai.vue?vue&type=script&lang=js"
export * from "./xiazai.vue?vue&type=script&lang=js"
import style0 from "./xiazai.vue?vue&type=style&index=0&id=366b857e&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports